<template>
  <div ref="wrapper" class="wrapper">
    <div v-if="isEmptyList" class="placeholder">
      {{ emptyText }}
    </div>
    <template v-if="!isEmptyList">
      <template v-for="(point, index) in filteredPointList">
        <Point
          :key="point.id"
          :point="point"
          :index="index"
          :last="filteredPointList.length - 1"
          :has-edit-permission="hasEditPermission"
        />
      </template>
    </template>
  </div>
</template>

<script>
import Point from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Point/Point'
import Velocity from 'velocity-animate'
import RouteHelper from '@/mixins/RouteHelper'
import { getters } from '@/vuex/modules/pointGroupOperation/constants'

export default {
  name: 'PointList',
  components: { Point },
  mixins: [RouteHelper],
  props: {
    pointList: Array,
    listOpen: Boolean,
    hasEditPermission: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isEmptyList() {
      return this.pointList.length === 0
    },
    emptyText() {
      return this.canEdit
        ? '地点を登録してください'
        : '地点が登録されていません'
    },
    canEdit() {
      return !this.underSystemOwnerPage
    },
    filteredPointList() {
      return this.$store.getters[getters.filteredPointList](this.pointList)
    },
  },
  methods: {
    beforeEnter: function(el) {
      el.style.opacity = 0
      el.style.height = 0
    },
    enter: function(el, done) {
      const delay = 0
      console.log('height', el)
      setTimeout(function() {
        Velocity(el, { opacity: 1, height: '37px' }, { complete: done })
      }, delay)
    },
    leave: function(el, done) {
      const delay = 0
      setTimeout(function() {
        Velocity(el, { opacity: 0, height: 0 }, { complete: done })
      }, delay)
    },
  },
}
</script>

<style scoped>
.wrapper {
  overflow: hidden;
  transition: height 0.3s;
  background: white;
}
.placeholder {
  background-color: #d5d5d5;
  padding: 5px 10px 5px 30px;
}
</style>
